import React from 'react';
import { connect } from 'react-redux';
import { TextField, FormControl, FormHelperText } from '@mui/material';
import * as types from 'constants/actionTypes';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';
import SecureComponent from '../SecureComponent';

class DecimalInput extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) {
            this.state = { ...this.state, value: props.value, error: "" };
        } else {
            this.state = { ...this.state, value: "", error: "" };
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        } else if (!newProps.value) {
            this.setState({ value: "" });
        }

        if (newProps.error && newProps.error !== this.state.error) {
            this.setState({ error: newProps.error });
        } else if (!newProps.error) {
            this.setState({ error: "" });
        }
    }

    onChange = (event) => {
        const value = event.target.value;
        const maskedStringValue = toMoneyTyping(value);
        const floatValue = parseFloat(maskedStringValue.replace(/,/g, '')) || 0;
        const min = parseFloat(this.props.min || 0);
        const max = parseFloat(this.props.max || 0);
        let finalFloatValue = floatValue;

        if (this.props.min !== undefined && floatValue <= min) {
            finalFloatValue = min
        }
        if (this.props.max !== undefined && floatValue >= max) {
            finalFloatValue = max;
        }

        const finalMaskedStringValue = toMoneyTyping((Math.round(finalFloatValue * 100 * 100) / 100));

        // console.log(value);
        this.setState({ value: finalMaskedStringValue });
        this.updateStore(finalMaskedStringValue);

        if (this.props.onChange){
            this.props.onChange(event);
        }
    }

    onBlur = () => {
        const error = this.validate(this.state.value);
        this.setState({ error });
        this.updateStore(this.state.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ value, error });
        if (value){
            this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: this.props.name });
            this.props.dispatch({ type: types.FORM_ERROR, name: this.props.name, error }); // Clear Redux error
        }

        if (this.props.name == "ProductSaveUnitPrice") {
            this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: "ProductSaveMemberUnitPrice" });

            (this.props.isHighTide || this.props.isInspired) &&
                this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: "ProductSavePromotionUnitPrice" });
            
        }

        if (this.props.name === "productPOUnitPrice") {
            let totalPrice = (parseFloat(value.replace(/,/g, '')) * this.props.poproductQuantity).toFixed(2);
            this.props.dispatch({ type: types.FORM_INPUT, value: totalPrice, name: "productPOTotalPrice" });
        }

        if (this.props.name === "productPOTotalPrice") {
            let unitPrice = (parseFloat(value.replace(/,/g, '')) / this.props.poproductQuantity).toFixed(2);
            this.props.dispatch({ type: types.FORM_INPUT, value: unitPrice, name: "productPOUnitPrice" });
        }
    }

    validate(value) {
        const p = this.props;
        let error = ``;
        if (!value && p.required) {
            error = p.errorMsg || `${p.name} is required`;
        }
        return error;
    }

    render() {
        const p = this.props;
        const s = this.state;
        const localError = s.error;
        const value = s.value;

        if (!s.authorized) return null;

        return (
            <div className={`form-group DecimalInput ${p.className || ``}`}>
                <FormControl
                    fullWidth
                    variant="standard"
                    error={Boolean(localError)}
                    id={p.name}
                    name={p.name}
                    className={`${p.className} ${Boolean(localError) ? 'error' : ''}`}
                >
                    <TextField
                        autoFocus={p.autoFocus}
                        name={p.name}
                        id={p.id || ''}
                        disabled={p.disabled}
                        value={toMoney(value)}
                        onChange={this.onChange}
                        onBlur={this.onBlur}
                        label={p.label || p.floatingLabelText}
                        InputProps={{ style: p.inputStyle }}
                        InputLabelProps={{ style: p.floatingLabelStyle }}
                        // helperText={p.hintText}
                        variant="standard"
                        placeholder={p.hintText}
                        error={Boolean(localError)}
                    />
                    {localError ? <FormHelperText>{localError}</FormHelperText> : null}
                </FormControl>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const appSettings = state.common.applicationSettings || {};
    return {
        value: state.form[props.name] || +props.value,
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel,
        poproductQuantity: state.form && state.form.productPOQuantity || 1,
        isHighTide: appSettings.isHighTide,
        isInspired: appSettings.isInspired
    };
};

export default connect(mapStateToProps)(DecimalInput);
